// src/config/routes.js
export const ROUTE_PERMS = {
  "/dashboard": "app.dashboard",
  "/dashboard/projects": "app.projects",
  "/dashboard/quotes": "app.quotes",
  "/dashboard/myquoets" : "app.myquotes",
  "/dashboard/quotes-org": "app.orgquotes",
  "/dashboard/estimator": "app.estimator",
  "/dashboard/subscription": "app.subscription",
  "/dashboard/support": "app.support",
  "/dashboard/engineering-plans": "app.engineeringplans",

  "/dashboard/staff": "app.staff",
  "/dashboard/pricing": "app.pricing", 
  "/dashboard/branding": "app.branding.edit",
  "/dashboard/branding-view": "app.branding.view",
  "/dashboard/autoestimator": "app.autoestimator",
  // admin
  "/admin": "admin.dashboard",
  "/admin/users": "admin.users",
  "/admin/projects": "admin.projects",
  "/admin/furnitures":"admin.furnitures",
  "/admin/assets": "admin.assets",
  "/admin/quotes": "admin.quotes",
  "/admin/subscriptions": "admin.subscriptions",
  "/admin/purchase-plans": "admin.purchaseplans",
  "/admin/reports": "admin.reports",
  "/admin/security": "admin.security",
  "/admin/revit":    "admin.revit",
  "/admin/editor-settings": "admin.editorsettings",

  "/ceed": "ceed.dashboard",
  "/ceed/furnitures":"ceed.furnitures",
  "/ceed/assets":"ceed.assets",
  "/ceed/projects":"ceed.projects",
  "/ceed/purchase-plans": "ceed.purchaseplans",
  "/ceed/quotes": "ceed.quotes",
  "/ceed/reports": "ceed.reports",
  "/ceed/notifications": "ceed.notifications",
  "/ceed/profile":"ceed.profile",
};
